import { isNumber, isString } from "./function-utils";

export const isEqual = (arr1, arr2) => {
	if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
		return false;
	}
	if (arr1.length !== arr2.length) {
		return false;
	}
	const sorted1 = [...arr1];
	const sorted2 = [...arr2];
	sorted1.sort();
	sorted2.sort();
	for (let i = 0; i < sorted1.length; i++) {
		if (sorted1[i] !== sorted2[i]) {
			return false;
		}
	}
	return true;
};

export const isNonEmptyArray = (arr1) => Array.isArray(arr1) && arr1.length > 0;

export const areNumbersInArrayConsecutive = (arr) => {
	if (!isNonEmptyArray(arr) || arr.some((n) => Number.isNaN(n))) {
		return false;
	}
	const unique = [...new Set(arr)];
	const decimals = unique.filter((n) => !Number.isInteger(n));
	const integers = unique.filter(Number.isInteger);
	const allIntegerParts = [...new Set([...integers, ...decimals.map((n) => Math.trunc(n))])].sort((a, b) => a - b);
	const integerSet = new Set(allIntegerParts);
	const allDecimalsAnchored = decimals.every((n) => integerSet.has(Math.trunc(n)));
	if (!allDecimalsAnchored) {
		return false;
	}
	let min = Math.min(...allIntegerParts);
	let num = 0;
	for (const element of allIntegerParts) {
		num = num ^ min ^ element; // eslint-disable-line no-bitwise
		min += 1;
	}
	return num === 0;
};

export const multiSort = (arr = [], sortBy = []) =>
	[...arr].sort((a, b) => {
		for (const prop of sortBy) {
			if (isString(a[prop]) && isString(b[prop])) {
				return a[prop].localeCompare(b[prop], undefined, { sensitivity: "base" });
			}
			if (isNumber(a[prop] && isNumber(b[prop]))) {
				if (a[prop] !== b[prop]) {
					return a[prop] < b[prop] ? -1 : 1;
				}
				return 0;
			}
			return 0;
		}
		return 0;
	});

export const flatSearchItems = (arr = [], searchedProp = "", subProp = "", subProp2 = "", subObjectProp = "") => {
	let result = [];
	for (const item of arr) {
		if (item?.[searchedProp] || (item?.[subObjectProp] && item[subObjectProp]?.[searchedProp])) {
			result.push(item);
		}
		if (isNonEmptyArray(item?.[subProp])) {
			result = result.concat(flatSearchItems(item[subProp], searchedProp, subProp, subProp2, subObjectProp));
		}
		if (isNonEmptyArray(item?.[subProp2])) {
			result = result.concat(flatSearchItems(item[subProp2], searchedProp, subProp, subProp2, subObjectProp));
		}
	}
	return result;
};
export const mergeLists = (originalList, updatedList, commonKey) => {
	/** Adds all new elements from updatedList to originalList based on commonKey prop */
	const pageMap = originalList.reduce((acc, item) => {
		acc[item[commonKey]] = item;
		return acc;
	}, {});
	updatedList.forEach((item) => {
		pageMap[item[commonKey]] = item;
	});
	return Object.values(pageMap);
};
export const findMinInNumberArray = (array, min, max) => {
	let missingMin = null;
	for (let i = min; i <= max; i++) {
		if (!array.includes(i)) {
			missingMin = i;
			break;
		}
	}
	return missingMin;
};
export const findMaxInNumberArray = (array, min, max) => {
	let missingMax = null;
	for (let i = max; i >= min; i--) {
		if (!array.includes(i)) {
			missingMax = i;
			break;
		}
	}
	return missingMax;
};
export const upsert = (array, item, key) => {
	const index = array.findIndex((el) => el[key] === item[key]);

	if (index !== -1) {
		array[index] = { ...array[index], ...item };
	} else {
		array.push(item);
	}

	return array;
};
